<div class="unauthpage-container">
  <div class="header">{{cfetLabels.utf_unauth_page.header}}</div>
  <p id="blue_text">{{cfetLabels.utf_unauth_page.content1}}</p>
  <p id="gray_text">{{cfetLabels.utf_unauth_page.content2}}</p>
  <div>
    <img id="img" src="assets/images/FirstNet.png" alt="Star">
  </div>
  <div class="form-group">
    <form [formGroup]="emailAddressForm">
      <div class="row no-gutters form-row" [class.error]="(emailAddressError || showDupeErrorMsg)">
        <div class="col-md-12">
          <label for="emailAddress" id="email_address">{{cfetLabels.cfet_customer_profile.email_add}}</label>
          <div class="email-address-inputbox">
            <input class="form-control" id="emailId" [(ngModel)]='userId' formControlName="emailAddress" tabindex="0"
              type="text" (blur)="validateEmailAddress()" (change)="onChangeEmail()" autocomplete="off" maxlength="256">
            <div *ngIf="emailAddressError || showDupeErrorMsg" role="alert" [attr.aria-atomic]="true"
              [ngClass]="{'error-msg' : (emailAddressError || showDupeErrorMsg)}">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="emailAddressError">{{cfetMessages.valid_emailAddress}}</span>
              <span *ngIf="showDupeErrorMsg">{{cfetMessages.emailAlreadyExists}}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <hr>
  <div class="col-12" class="btn-container">
    <a tabindex="0" type="button" id="cancel_link" class="utf-cancel-link" (click)="cancelModal($event)"
      (keyup)="cancelModal($event)">
      <em aria-label=""></em>
      {{cfetButtonLabels.button_labels.cancel}}</a>
    <button tabindex="0" type="button" id="btn-continue" class="utf-button-blue" (click)="continue($event)"
      (keyup)="continue($event)" [disabled]="disabledContinueButton"><em aria-label=""></em>
      {{cfetButtonLabels.button_labels.continue}}</button>
  </div>
</div>
<div [ngClass]="showCancelModal ? 'open-eligibility-step-cancel-modal' : 'hide-cancel-modal'">
  <app-cancel-eligibility-step-modal [openModal]="openCancelModal" (closeModal)="closeModal($event)">
  </app-cancel-eligibility-step-modal>
</div>